import { rem, size } from "polished";
import styled from "styled-components";
import media from "styled-media-query";

import { themes } from "styles";
import { FeatherIcons } from "../../Icons";

export const Container = styled.div`
  padding: 16px;

  display: inline-flex;
  align-items: flex-start;

  border-radius: 8px;
  background-color: ${themes.page.colors.content};

  ${media.greaterThan("huge")`
    padding: 24px;
  `}
`;

export const Icon = styled(FeatherIcons).attrs(() => ({ name: "map" }))`
  ${size("16px")}

  margin-right: 16px;

  stroke-width: 1.2px;
  color: ${themes.palletes.primary};

  ${media.greaterThan("huge")`
    ${size("24px")}

    margin-right: 24px;
  `}
`;

export const Content = styled.div`
  line-height: 180%;
  font-size: ${rem("8px")};
  color: ${themes.text.high};

  ${media.greaterThan("huge")`
    font-size: ${rem("12px")};
  `}
`;

export const Heading = styled.p`
  margin-bottom: 4px;

  font-weight: 500;
  font-size: ${rem("8px")};
  color: ${themes.text.low};

  ${media.greaterThan("huge")`  
    margin-bottom: 8px;

    font-size: ${rem("12px")};
  `}
`;

export const Action = styled.button`
  all: unset;

  margin-top: 8px;
  cursor: pointer;
  color: ${themes.palletes.primary};

  &:hover {
    text-decoration: underline;
  }
`;
